module.exports = "/assets/data/47399f1f889580b2f0c2188ca2b41e45-L26.data.json";